import { gql } from '@apollo/client';
import { CODE_FRAGMENT, IDENTIFIER_FRAGMENT } from '../../shared/fragments';

export const FETCH_ALL_CARETEAMS_QUERY = gql`
  query fetchAllCareTeams(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllCareTeams(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      careTeamList
      count
    }
  }
`;

export const FETCH_CARETEAM_BY_ID_QUERY = gql`
  query fetchCareTeamById($careTeamId: String) {
    fetchCareTeamById(careTeamId: $careTeamId) {
      careTeam
      carePlans
    }
  }

`;


// export const FETCH_CARETEAM_BY_ID_QUERY = gql`
//   query fetchCareTeamById($careTeamId: String) {
//     fetchCareTeamById(careTeamId: $careTeamId) {
//       id
//       status
//       name
//       category {
//         ...code
//         system
//         code
//       }
//       period {
//         start
//         end
//       }
//       note {
//         text
//       }
//       telecom {
//         system
//         value
//         use
//         rank
//         period {
//           start
//           end
//         }
//       }
//       participant {
//         role {
//           ...code
//           system
//           code
//         }
//         member {
//           reference
//           display
//           identifier {
//             ...identifier
//           }
//         }
//         onBehalfOf {
//           reference
//           display
//           identifier {
//             ...identifier
//           }
//         }
//       }
//       identifier {
//         ...identifier
//       }
//       reasonCode {
//         code
//         text
//         system
//         coding {
//           system
//           code
//           display
//         }
//       }
//     }
//   }
//   ${IDENTIFIER_FRAGMENT}
//   ${CODE_FRAGMENT}
// `;
